var _rect, _polygon, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPtBr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    fill: "#6DA544",
    width: 512,
    height: 341.3
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFDA44",
    points: "256,19.3 461.4,170.7 256,322 50.6,170.7  "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 256,
    cy: 170.7,
    r: 86.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M212.8,165.3c-15,0-29.5,2.3-43.2,6.5c0.6,47.2,39.1,85.3,86.4,85.3c29.3,0,55.2-14.6,70.8-36.9 C300.1,186.8,258.9,165.3,212.8,165.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M340.9,187.2c1-5.4,1.6-10.9,1.6-16.6c0-47.8-38.7-86.5-86.5-86.5c-35.6,0-66.2,21.6-79.5,52.3 c11.7-2.4,23.8-3.7,36.2-3.7C263,132.8,308.4,153.7,340.9,187.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPtBr);
export default __webpack_public_path__ + "static/media/pt_BR.89a32225a345b4cb6d579422df74face.svg";
export { ForwardRef as ReactComponent };